import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Input } from "../../../../Components/Form";
import { email, required } from "../../../../modules/validation";
import { ButtonPrimary } from "../../../../Components/Button";
import { createUser } from "../../../../redux/actions";
import { token } from "../../../../modules/auth";

const v = {
  firstName: required("Please enter your first name"),
  surname: required("Please enter your surname"),
  email: required("Please enter your email address"),
  phone: required("Please enter your phone"),
};

function DummyCompanyUserForm({ handleSubmit, createUser, token, company }) {
  const onSubmit = formValues => {
    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, value);
      }
    });
    if (!company) return;
    formData.append("user_type_id", 1);
    formData.append("suppress_notifications", 1);
    formData.append("company_id", company?.company?.id);
    return createUser(token, formData);
  };

  return (
    <>
      <form className="border-none" onSubmit={handleSubmit(onSubmit)}>
        <div className={"row"}>
          <div className="col col-w-full mb-6">
            <Field
              name="first_name"
              label="First name"
              validate={v.firstName}
              component={Input}
            />
            <Field
              name="surname"
              label="Surname"
              validate={v.surname}
              component={Input}
            />
            <Field
              name="email"
              type="email"
              label="Email address"
              validate={[v.email, email]}
              component={Input}
            />
            <Field
              component={Input}
              name="phone"
              label="Phone"
              validate={v.phone}
            />
          </div>
          <div className="col">
            <ButtonPrimary type="submit">Save</ButtonPrimary>
          </div>
        </div>
      </form>
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state,
    token: token(state),
  };
};

const mapDispatchToProps = {
  createUser,
};

export default reduxForm({
  form: "dummyCompanyUserForm",
  enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(DummyCompanyUserForm));
